import React, { useState } from "react"
import "./../../CompanysForm.css"

import { PaginationGrid } from "../../../../../../components/Common/PaginationGrid"

import XPTable from "./XPTable"
import XPForm from "./XPForm"

const XPGrid = ({
  data,
  currentPage,
  setCurrentPage,
  showList,
  setShowList,
  totalPages,
  companySelected,
  setCompanySelected,
}) => {
  return (
    <>
      {showList ? (
        <>
          {!!data.length && (
            <>
              <XPTable
                dataArray={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setCompanySelected={setCompanySelected}
                setShowList={setShowList}
                totalPages={totalPages}
              />
            </>
          )}
        </>
      ) : (
        <XPForm
          companySelected={companySelected}
          setCompanySelected={setCompanySelected}
          showList={showList}
          setShowList={setShowList}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  )
}

export default XPGrid
